import { Button } from "@chakra-ui/button";
import { Heading, Stack } from "@chakra-ui/layout";
import React from "react";
import { signIn } from "next-auth/react";
import { useRouter } from "next/dist/client/router";
import { textStyle } from "theme/names";

const ProtectedRoute = () => {
  const baseUrl =
    !process.env.NODE_ENV || process.env.NODE_ENV === "development"
      ? "http://localhost:3003"
      : "https://app.taplio.com";

  const router = useRouter();

  return (
    <Stack maxW={400} spacing={4} margin="auto" mt="5vh">
      <Heading fontSize="2xl" textAlign="center"
        textStyle={textStyle["h4.bold.standard"]}
        >
        You have been logged out.
      </Heading>
      <Heading p={10} fontSize="lg" textAlign="center"
        textStyle={textStyle["h2.bold.standard"]}
      >
        Please login to continue using the app. 
      </Heading>
      <Button
        variant = "primary"
        // colorScheme="linkedin"
        onClick={() => {
          // router.push("/signin?action=signin");
          let currentUrl = window?.location?.href;
          if (!currentUrl)
            currentUrl = baseUrl + "/subscribe";
          signIn("auth0", {callbackUrl: currentUrl}, { initialScreen: 'signIn', screen_hint: 'signin' })
        }}
      >
        Sign in
      </Button>
    </Stack>
  );
};

export default ProtectedRoute;
